import * as React from "react";

type Size = "node" | "badge";

const SIZE: Record<Size, string> = {
  node: "h-16 w-16 text-[20px] border-[3px]",
  badge: "h-7 w-7 text-[12px] border",
};

/** Circular outlined index marker. Two fixed sizes: `node` (desktop timeline
 *  spine — double ring: thick outer + thin inner, per the About comp) and
 *  `badge` (mobile card header). Token-driven; no className escape. */
export function StepNumber({ n, size = "node" }: { n: string; size?: Size }) {
  return (
    <span
      className={`${SIZE[size]} relative inline-flex flex-none items-center justify-center rounded-full border-primary bg-white font-medium tracking-[0.08em] text-primary`}
    >
      {size === "node" ? (
        <span
          aria-hidden="true"
          className="absolute inset-[4px] rounded-full border border-primary/60"
        />
      ) : null}
      {n}
    </span>
  );
}
